export const LazyLinkSignatureService = Symbol.for('LazyLinkSignatureService');
